import { TranslatedString } from "../translated-string"

export const WORK_SCHEMAS = [
    "indexation",
    "identificationWorkSchema",
    "descriptionWorkSchema",
    "eventWorkSchema",
    "linkWorkSchema",
    "historicWorkSchema",
    "canCreateVariant",
]

export const MUSEUM_WORK_SCHEMAS = WORK_SCHEMAS.concat([
    "descriptionMuseumWorkSchema",
    "historicMuseumWorkSchema",
])

export interface Work {
    id: string
    type: string
    entityType?: string
    descriptionMuseumWorkSchema?: DescriptionMuseumWorkSchemaResource | null
    descriptionWorkSchema?: any
}

export interface DescriptionMuseumWorkSchemaResource {
    representations?: Array<RepresentationResource> | null 
    workTitles?: Array<WorkTitleResource> | null 
}

interface RepresentationResource {
    iconographicType?: string | null
    topics?: Array<TopicResource> | null
    emplacements?: Array<string> | null
    personDepicteds?: Array<PersonDepictedResource> | null 
    datesEras?: Array<TranslatedString> | null
    sources?: Array<string> | null
    precision?: Array<TranslatedString> | null 
    notes?: Array<TranslatedString> | null
}

interface TopicResource {
    topic?: string | null
    topicQualifier?: string | null
    precision?: Array<TranslatedString> | null 
}

interface PersonDepictedResource {
    person?: string | null
    precision?: TranslatedString | null
}

export interface WorkTitleResource {
    principal?: boolean | null
    title?: TranslatedString | null
    prefix?: TranslatedString | null
    fullTitle?: TranslatedString | null
    typeOfTitle?: TranslatedString | null
    titleLanguage?: string | null
    source?: TranslatedString | null
    precision?: TranslatedString | null
    notes?: Array<TranslatedString> | null
}